import React from 'react'

import {
	RadioGroup,
	RadioRow,
	Radio,
	RadioActiveCircle,
	RadioIcon,
	RightFade,
} from './RadioForm.styles'

interface RadioFormProps<T> {
	items: Array<T>,
	renderItem: ({ active, item }: { active: boolean, item: T }) => any,
	keyExtractor: (item: T) => string | number,
	getFade: (item: T) => { width: string, rightEndPercent: number },
	onSelected: (item: T) => any,
	selected: T | null,
	background: string,
	selectionBackground: string,
}

export default function RadioForm<T>(
	{
		items,
		renderItem,
		keyExtractor,
		getFade,
		onSelected,
		selected,
		background,
		selectionBackground,
		...props
	}: RadioFormProps<T>,
) {

	return (
		<RadioGroup {...props}>
			{
				items.map((item) => {
					const currentKey = keyExtractor(item)
					const active = currentKey === (selected && keyExtractor(selected))
					const fadeProps = getFade(item)

					return (
						<RadioRow
							key={currentKey}
							onClick={() => onSelected(item)}
							className={active ? 'active' : ''}

							background={background}
							selectionBackground={selectionBackground}
						>
							<Radio>
								<RadioIcon
									active={active}
								/>
								{
									active && (
										<RadioActiveCircle
											innerCircleColor={selectionBackground}
										/>
									)
								}
							</Radio>
							{renderItem({ active, item })}
							<RightFade
								key={active as any}
								active={active}
								fadeWidth={fadeProps.width}
								fadeEndPercent={fadeProps.rightEndPercent}
								background={background}
								selectedBackground={selectionBackground}
							/>
						</RadioRow>
					)
				})
			}
		</RadioGroup>
	)
}
